<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1400px"
      unit="请购单"
      edit-title
      id-key="commentId"
      form-label-width="110px"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @details-opened="detailsOpened"
      :show-save-button="showSaveButton"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <div class="border"> 
            <el-row>
              <el-col :span="6">
                <el-form-item label="单据编号" prop="DocNo">
                  <el-input v-model="data.DocNo" placeholder="请输入单据编号" v-if="noEdit"></el-input>
                  <span v-else>{{ data.DocNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="单据日期" prop="DocDate">
                  <el-date-picker
                    v-model="data.DocDate"
                    placeholder="请选择日期"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :editable="false"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="供应商" prop="SupplierId">
                  <supplier @restaurants="setSupplier" :state="data.SupplierName" />
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item label="预计到货日期">
                  <el-date-picker
                    v-model.trim="data.DeliveryDate"
                    placeholder="请选择日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="业务员" prop="ClerkName">
                  <el-input v-model="data.ClerkName" @focus="addEmp" style="width:220px;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注" prop="Remark">
                  <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <dialog-list ref="dialogList" :readonly="readonly" :disposeTax="DisposeTax" :info="data" @getList="getList" :show-select-btn="isShowSelectBtn" />
        </el-row>
      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/sales/business/empDialog";
import dialogList from "./dialogList";
import supplier from "@/components/common/supplier/supplier";
export default {
  props: {
    DisposeTax: {
      type: [String, Number],
      default: "",
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    }
  },
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    empDialog,
    supplier,
  },
  data() {
    return {
      isShowSelectBtn: true, // 是否显示商品选择按钮
      data: {
        SupplierId: null,
        SupplierName: "",
        OrderId: 0,
        CustomerId: null,
        CustomerName: "",
        CustomerType: null,
        DocNo: "",
        DocDate: "",
        Status: 0,
        Source: 0,
        Remark: "",
        CouponCustomerId: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        PayAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ReceiptConditionId: null,
        ClerkName: "",
        ClerkId: 0,
        //----
        DeliveryDate: "",
        // DisposeTax:null,
        Goods: [],
        Pays: [],
      },
      
      noEdit: false,
      recList: [],
      recDel: [],
      tableData: [],
      accountList: [],
      settleList: [],
      recCon: [],
      cList: [],
      eqType: null,
      // PriAdjustEmpList: [],
      api: require("@/api/purchase/predict").default,
      recApi: require("@/api/sy/RecCon").default,
      settleApi: require("@/api/sale/settle").default,
      accountApi: require("@/api/sale/account").default,
      billApi: require("@/api/sy/bill").default,
      optApi: require("@/api/sy/opt").default,
      readonly: false,
      rules: {
        Source: [{ required: true, message: "订单来源不能为空" }],
        SupplierId: [{ required: true, message: "请选择供应商" }],
        // ClerkName: [{ required: true, message: "业务员不能为空" }],
      },
    };
  },
  beforeMount() {
    if (!this.data.DocDate) {
      this.data.DocDate = this.$commonJs.getToday();
    }
    this.settleApi
      .list({ Status: 1, PageIndex: 1, PageSize: 100 })
      .then((res) => {
        this.settleList = res.Data;
      });
    this.accountApi
      .list({ Status: 1, PageIndex: 1, PageSize: 100 })
      .then((res) => {
        this.accountList = res.Data;
      });
    this.recApi.list({ PageIndex: 1, PageSize: 100 }).then((res) => {
      this.recCon = res.Data;
    });
  },
  methods: {
    setReadonly(bool){
      this.readonly = bool;
    },
    // 查看预购单明细
    detailsOpened(data){
      
       this.$refs.dialogList.setDetail(data.Goods)
      
    },
    // 控制商品选择按钮的显示与隐藏
    changeShowSelectBtn(bool){
      this.isShowSelectBtn = bool
    },
    setSupplier(data) {
      this.data.SupplierId = data.TradeUnitId;
      this.data.SupplierName = data.TradeUnitName;
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    addsalesorder(e) {
      this.$refs.orderDialog.open().then((that) => {
        that.getData({ Status: 2 });
      });
    },
    setUnit(e) {
      let tableData = this.$refs.dialogList.tableData;
      if (!tableData.some((v) => v.GoodsId)) {
        this.$refs.dialogList.tableData = [];
      }
      e.forEach((v) => this.$refs.dialogList.setGoods(v));
      // this.$refs.dialogList.addGoods();
    },
    getList(list) {
      this.tableData = list;
      let Amount = null;
      let TaxAmount = null;
      let PayAmount = this.data.PayAmount || 0;
      list.forEach((item) => {
        if (item.T != 2) {
          Amount += Number(item.Amount);
          TaxAmount += Number(item.TaxAmount);
        }
      });
      this.data.Amount = Amount;
      this.data.TaxAmount = TaxAmount;
      this.data.NoTaxAmount = Amount - TaxAmount;
      this.data.RemainAmount = Amount - PayAmount;
    },
    saChange(index) {
      if (this.recList[index].OrderReceiptId && this.recList !== 1) {
        this.recList[index].T = 1;
      }
    },
    recChange(index, type) {
      let PayAmount = 0;
      let Amount = this.data.Amount;
      if (!Amount) {
        Amount = 0;
      }
      this.recList.forEach((item) => {
        if (item.PayAmount) {
          PayAmount += Number(item.PayAmount);
        }
      });
      if (type != "del") {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 1;
        }
      }
      this.data.PayAmount = Number(PayAmount);
      this.data.RemainAmount = this.data.Amount - this.data.PayAmount;
    },
    add() {
      this.recList.push({
        T: 0,
        DocReceiptId: 0,
        OrderReceiptId: 0,
        OrderId: this.data.OrderId,
        SettleId: null,
        AccountId: null,
        PayAmount: 0,
        AddTime: this.data.DocDate,
      });
    },
    del(index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 2;
          this.recDel.push(this.recList[index]);
        }
        this.recList.splice(index, 1);
        this.recChange(index, "del");
      });
    },
    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1, IsSales: true });
      });
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId;
      this.data.ClerkName = e.EmpName;
    },
    onCreateOpened() {
      this.cList = JSON.parse(sessionStorage.getItem("cList"));
      this.$refs.dialogList.tableDel = [];
      this.$refs.dialogList.tableData = [
        {
          T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId: "",
          Model: "",
          UnitId: null,
          UnitName: "",
          UnitId1: null,
          UnitId2: null,
          Quantity: 0,
          Quantity1: 0,
          Quantity2: 0,
          BatchNo: "",
          Offer: 0,
          Discount: 100,
          Price: 0,
          NoTaxPrice: 0,
          ExistQuantity: 0,
          AvailableQuantity: 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: 0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: "",
          WholesalePrice: "",
          SupplierName: '',
          SupplierId: '',
        },
      ];
      this.recList = [];
      var user = this.$store.state.user;

      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.billApi.getDefaultSerialNo("请购单").then((res) => {
        if (res.Code == 0 && res.Data) {
          this.data.DocNo = res.Data;
        } else if (res.Code == 0) {
          this.noEdit = true;
        } else {
          this.$message.warning(res.Msg);
        }
      });
    },
    onEditOpened(row) {
      this.$refs.dialogList.tableDel = [];
      this.$refs.dialogList.getData();
      this.cList = JSON.parse(sessionStorage.getItem("cList"));
      if (this.data.ReceiptConditionId == 0) {
        this.data.ReceiptConditionId = null;
      }

      this.recList = this.data.Pays;
    },
    onBeforeSave() {
      // return false
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      let tb = [];
      if (tableData.length == 0 || !tableData.some((v) => v.GoodsId)) {
        this.$message.error("请填写商品列表");
        return false;
      }
      for (var i = 0; i < tableData.length; i++) {
        if (tableData[i].GoodsId) {
          if (!(tableData[i].Quantity > 0)) {
            this.$message.error("请填写正确数量");
            return false;
          }
          if (!tableData[i].Discount) {
            tableData[i].Discount = 100;
          }
          if (this.eqType === 1) {
            if (tableData[i].Quantity > tableData[i].ExistQuantity) {
              this.$message.warning("存在商品数量大于现存量");
            }
          }
          if (this.eqType === 2) {
            if (tableData[i].Quantity > tableData[i].ExistQuantity) {
              this.$message.error("数量不可大于现存量");
              return false;
            }
          }
          if (!tableData[i].TaxRate) {
            tableData[i].TaxRate = 0;
          }
          if (!tableData[i].Discount) {
            tableData[i].Discount = 100;
          }
          if (tableData[i].T === 0 || tableData[i].T === 1) {
            this.$delete(tableData[i], "unit");
            this.$delete(tableData[i], "Rate1");
            this.$delete(tableData[i], "Rate2");
            tb.push(tableData[i]);
          }
        }
      }
      //
      this.data.Goods = tb.concat(tableDel);
      // if(!this.data.RemainAmount&&this.data.RemainAmount!==0||this.recList.length==0) {
      //   this.$message.error("请填写收款信息");
      //   return false
      // }
      if (this.data.ReceiptConditionId === null) {
        this.data.ReceiptConditionId = 0;
      }
      let rec = [];
      this.recList.forEach((item) => {
        if (item.T || item.T === 0) {
          rec.push(item);
        }
      });
      for (var i = 0; i < rec.length; i++) {
        if (!rec[i].SettleId) {
          this.$message.error("请选择结算方式");
          return false;
        }
        if (!rec[i].AccountId) {
          this.$message.error("请选择收款账号");
          return false;
        }
        if (!(rec[i].PayAmount > 0)) {
          this.$message.error("请填写正确收款金额");
          return false;
        }
      }
      this.data.Pays = rec.concat(this.recDel);
      // this.data.Pays.forEach(item => {
      //   if(!item.SettleId) {
      //     item.SettleId = 0
      //   }
      //   if(!item.AccountId) {
      //     item.AccountId = 0
      //   }
      // })

      return true;
    },
  },
};
</script>
<style lang="scss">
.is-disabled {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
  }
}
.border {
  padding: 15px 25px 0 0;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>